/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ModuleManifest } from "shared/bootstrap";
import moment from "moment";
import publicLocale from "./i18n/public.json";
import adminLocale from "./i18n/admin.json";
import "moment/locale/nl";
import { VuePlugins } from "shared/bootstrap/types";

moment.locale("nl");

const manifest: ModuleManifest = {
  menuItems: [
    {
      to: { name: "login-request" },
      title: "base.menuItems.login",
      icon: "sign-in-alt",
      hideAuth: true
    },
    {
      to: { name: "logout" },
      title: "base.menuItems.logout",
      icon: "sign-out-alt",
      hideNoAuth: true,
      bottom: true
    }
  ],
  routes: [
    {
      path: "/login",
      component: () => import("./layouts/Auth.vue"),
      children: [
        {
          path: "/",
          name: "login-request",
          meta: {
            title: "base.menuItems.login",
            auth: false
          },
          component: () => import("./pages/LoginRequest.vue")
        },
        {
          path: ":token",
          name: "login-process-token",
          props: true,
          meta: {
            title: "base.menuItems.login"
          },
          component: () => import("./pages/LoginProcessToken.vue")
        }
      ]
    },
    {
      path: "/logout",
      component: () => import("./layouts/Auth.vue"),
      children: [
        {
          path: "/",
          name: "logout",
          meta: {
            title: "base.menuItems.logout"
          },
          component: () => import("./pages/Logout.vue")
        }
      ]
    }
  ],
  localisation: { key: "base", messages: publicLocale }
};

export default manifest;

export const AdminManifest: ModuleManifest = {
  menuItems: [
    {
      to: { name: "login-stats" },
      title: "base.menuItems.loginStats",
      icon: "users"
    }
  ],
  routes: [
    {
      path: "/login-statistieken",
      name: "login-stats",
      component: () => import("./pages/LoginStats.vue"),
      meta: {
        title: "base.menuItems.loginStats"
      }
    }
  ],
  vuePlugins: [VuePlugins.CompendaIntegration],
  localisation: { key: "base", messages: adminLocale }
};
